<template>
  <div class="max-w-3xl mx-auto">
    <Head title="Editar categoría de producto" />
    
    <!-- Header -->
    <div class="mb-8">
      <div class="flex items-center gap-4 text-sm text-gray-500 mb-2">
        <button class="hover:text-orange-500 transition-colors" @click="back">
          <i class="fa fa-arrow-left" />
        </button>
        <Link href="/product-categories" class="hover:text-orange-500 transition-colors">Categorías de Productos</Link>
        <span class="text-gray-300">/</span>
        <span class="text-gray-900 font-medium">{{ form.name }}</span>
      </div>
      
      <div class="flex items-center gap-3">
        <h1 class="text-2xl font-bold text-gray-900">Editar Categoría</h1>
      </div>
      <p class="text-gray-500 mt-1">Actualice la información de la categoría.</p>
    </div>

    <!-- Form -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <form @submit.prevent="update">
        <div class="p-8">
          <h2 class="text-base font-bold text-gray-900 mb-6 flex items-center gap-2">
            <i class="fa fa-info-circle text-orange-500" />
            Información de la Categoría
          </h2>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Name -->
            <div class="space-y-1.5">
              <label class="block text-sm font-medium text-gray-700">Nombre *</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i class="fa fa-tag text-gray-400" />
                </div>
                <input 
                  v-model="form.name"
                  type="text" 
                  class="block w-full pl-10 pr-3 py-2.5 bg-white border border-gray-200 rounded-lg focus:ring-orange-500 focus:border-orange-500 placeholder-gray-400 transition-colors text-sm"
                  :class="{'border-red-300': form.errors.name}"
                  placeholder="Ingrese el nombre de la categoría"
                />
              </div>
              <p v-if="form.errors.name" class="text-red-500 text-xs mt-1">{{ form.errors.name }}</p>
            </div>

            <!-- Code -->
            <div class="space-y-1.5">
              <label class="block text-sm font-medium text-gray-700">Código</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i class="fa fa-barcode text-gray-400" />
                </div>
                <input 
                  v-model="form.code"
                  type="text" 
                  class="block w-full pl-10 pr-3 py-2.5 bg-white border border-gray-200 rounded-lg focus:ring-orange-500 focus:border-orange-500 placeholder-gray-400 transition-colors text-sm"
                  :class="{'border-red-300': form.errors.code}"
                  placeholder="Ingrese el código de la categoría"
                />
              </div>
              <p v-if="form.errors.code" class="text-red-500 text-xs mt-1">{{ form.errors.code }}</p>
            </div>
          </div>
        </div>

        <!-- Submit -->
        <div class="flex items-center justify-between px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button 
            class="px-4 py-2 text-red-600 bg-red-50 hover:bg-red-100 font-medium rounded-lg transition-colors text-sm flex items-center gap-2"
            type="button"
            @click="destroy"
          >
            <i class="fa fa-trash" />
            Eliminar
          </button>
          <loading-button 
            :loading="form.processing" 
            class="px-6 py-2 bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-lg transition-colors flex items-center gap-2 shadow-sm"
            type="submit"
          >
            <i class="fa fa-save" />
            Actualizar categoría
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
  },
  layout: Layout,
  props: {
    productCategory: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.productCategory?.name,
        code: this.productCategory?.code,
      }),
    }
  },
  methods: {
    back() {
      window.history.back()
    },
    update() {
      this.form.put(`/product-categories/${this.productCategory.id}`)
    },
    destroy() {
      if (confirm('¿Está seguro que desea eliminar esta categoría?')) {
        this.$inertia.delete(`/product-categories/${this.productCategory.id}`)
      }
    },
  },
}
</script>
